module.exports = __webpack_public_path__ + "img/alex_journey_grey.f1d696a1.svg";